import React from 'react'
import { CurrentTemplate } from './'

const Default = props => (
  <CurrentTemplate
    chapter={props.chapter} />
)

export default Default
